// This is used for testing purposes. There is code that uses window
// that requires mock the functionality of.
export function getWindow() {
  return window;
}